// csgfReportingService.js
import apiClient from '../utils/apiClient';

const BASE = '/v2/admin/csgf';

const buildParams = ({ month, refresh = false, excludeStaff = true } = {}) => {
  const params = new URLSearchParams();
  if (month) params.append('month', month);
  if (refresh) params.append('refresh', '1');
  params.append('excludeStaff', excludeStaff ? '1' : '0');
  return params;
};

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const csgfReportingService = {
  /** Partnership Update metrics and product usage for a reporting month */
  getReport: (options) => apiClient.get(`${BASE}/report?${buildParams(options)}`),

  /**
   * The records behind one metric cell.
   * @param {'eligible'|'engaged'|'all_active'|'active_networks'} segment
   * @param {'users'|'networks'|'schools'|'relationships'} entity
   */
  getDetails: (segment, entity, options) => {
    const params = buildParams(options);
    params.append('segment', segment);
    params.append('entity', entity);
    return apiClient.get(`${BASE}/report/details?${params}`);
  },

  downloadDetails: async (segment, entity, options) => {
    const params = buildParams(options);
    params.append('segment', segment);
    params.append('entity', entity);
    params.append('format', 'csv');
    const blob = await apiClient.get(`${BASE}/report/details?${params}`, { responseType: 'blob' });
    downloadBlob(blob, `csgf-${options?.month || 'latest'}-${segment}-${entity}.csv`);
  },

  downloadReport: async (options) => {
    const blob = await apiClient.get(`${BASE}/report/export.xlsx?${buildParams(options)}`, {
      responseType: 'blob',
    });
    downloadBlob(blob, `CSGF_Partnership_Update_${options?.month || 'latest'}.xlsx`);
  },

  downloadRawUsers: async (options) => {
    const params = new URLSearchParams();
    if (options?.month) params.append('month', options.month);
    const blob = await apiClient.get(`${BASE}/raw-users.csv?${params}`, { responseType: 'blob' });
    downloadBlob(blob, `CSGF_raw_users_${options?.month || 'latest'}.csv`);
  },
};

export { csgfReportingService };
export default csgfReportingService;
